import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
type params = {
    textList: string[] | number[] | JSX.Element[];
    currentText: string | number | JSX.Element;
    customClass?: string;
};
export default function ScrollText({ textList, currentText, customClass }: params) {
    const { useEffect, useState, useRef } = useGlobal();
    const [translateY, setTranslateY] = useState(20);
    const ref = useRef();
    useEffect(() => {
        const textContainer = ref.current?.querySelector('.scroll-text-wrapper .text-list');
        if (!textContainer) return;
        const itemHeight = textContainer.clientHeight / textList.length;
        const currentIndex = textList.findIndex((textItem) => textItem === currentText);
        const nextTranslateY = itemHeight * currentIndex;
        setTranslateY(nextTranslateY);
    }, [currentText]);
    return (
        <div ref={ref} className={`${css.scroll_text} ${customClass} scroll-text-wrapper`}>
            <ul className="text-list" style={{ transform: `translateY(${-translateY}px)` }}>
                {textList.map((textItem, index) => (
                    <li key={index}>{textItem}</li>
                ))}
            </ul>
        </div>
    );
}
